import React from 'react';
import { Button } from '@mui/material';
import { MdClose, MdVisibility } from 'react-icons/md';
import Pagination from '../../../components/common/Pagination';

const ViewFilesModal = ({
  isOpen,
  onClose,
  staticFileList,
  currentPage,
  itemsPerPage,
  onViewFile,
  onPageChange
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div
        className="modal-container bg-white"
        style={{
          maxWidth: '90%',
          width: '90%',
          maxHeight: '90vh',
          height: 'auto',
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div className="row justify-content-center align-items-center bg-white z-index-1">
          <div className="col-12 d-flex justify-content-between align-items-center py-3 border-bottom">
            <h5 className="m-0 px-2">View Files</h5>
            <button className="border-0 bg-transparent" onClick={onClose}>
              <MdClose color="black" fontSize={20} role="button" />
            </button>
          </div>
        </div>

        <div className="modal-body p-3">
          <div className="mb-4">
            <h6 className="mb-3">File List</h6>
            <div className="table-responsive border rounded bg-white shadow-sm">
              <table className="table table-bordered table-striped mb-0">
                <thead className="table-dark">
                  <tr>
                    <th>#</th>
                    <th>File Name</th>
                    <th>Load Date</th>
                    <th>Load Time</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {staticFileList
                    .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                    .map((row, index) => (
                      <tr key={row.id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{row.fileName}</td>
                        <td>{row.loadDate}</td>
                        <td>{row.loadTime}</td>
                        <td className="text-center">
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<MdVisibility />}
                            onClick={() => onViewFile(row)}
                          >
                            View
                          </Button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-end mt-3">
              <Pagination
                currentPage={currentPage}
                totalPages={Math.ceil(staticFileList.length / itemsPerPage)}
                onPageChange={onPageChange}
              />
            </div>
            
          </div>
            <div className="d-flex justify-content-end ">
            <button className="btn createButton" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewFilesModal;
